import React, { useState } from 'react';
import { X } from 'lucide-react';
interface BounceHouseSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (bounceHouse: string) => void;
  packageName: string;
}
export const BounceHouseSelectionModal: React.FC<BounceHouseSelectionModalProps> = ({
  isOpen,
  onClose,
  onSelect,
  packageName
}) => {
  const [selectedBounceHouse, setSelectedBounceHouse] = useState<string>('');
  if (!isOpen) return null;
  const handleConfirm = () => {
    if (selectedBounceHouse) {
      onSelect(selectedBounceHouse);
      onClose();
    }
  };
  return <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-41">
      <div className="flex min-h-screen items-center justify-center p-4" data-id="element-42">
        {/* Backdrop */}
        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose} data-id="element-43"></div>

        {/* Modal */}
        <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full p-6 z-10" data-id="element-44">
          <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600" data-id="element-45">
            <X className="h-6 w-6" data-id="element-46" />
          </button>

          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-47">
            Select Your Bounce House
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-48">
            The {packageName} includes your choice of bounce house. Please
            select one:
          </p>

          <div className="space-y-3 mb-6" data-id="element-49">
            <label className="flex items-start p-4 border-2 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors" data-id="element-50">
              <input type="radio" name="bounceHouse" value="combo-white-bounce-house" checked={selectedBounceHouse === 'combo-white-bounce-house'} onChange={e => setSelectedBounceHouse(e.target.value)} className="mt-1 h-4 w-4 text-primary-500 border-gray-300 focus:ring-primary-500" data-id="element-51" />
              <div className="ml-3" data-id="element-52">
                <span className="block font-medium text-gray-900" data-id="element-53">
                  Combo White Bounce House w/ Ball Pit
                </span>
                <span className="block text-sm text-gray-600" data-id="element-54">
                  Large bounce house with curved slide and Ball Pit
                </span>
              </div>
            </label>

            <label className="flex items-start p-4 border-2 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors" data-id="element-55">
              <input type="radio" name="bounceHouse" value="mega-white-combo-bounce-house" checked={selectedBounceHouse === 'mega-white-combo-bounce-house'} onChange={e => setSelectedBounceHouse(e.target.value)} className="mt-1 h-4 w-4 text-primary-500 border-gray-300 focus:ring-primary-500" data-id="element-56" />
              <div className="ml-3" data-id="element-57">
                <span className="block font-medium text-gray-900" data-id="element-58">
                  Combo White Bounce House
                </span>
                <span className="block text-sm text-gray-600" data-id="element-59">
                  Larger bounce house with slide no Ball Pit
                </span>
              </div>
            </label>
          </div>

          <div className="flex gap-3" data-id="element-60">
            <button onClick={onClose} className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 font-medium hover:bg-gray-50 transition-colors" data-id="element-61">
              Cancel
            </button>
            <button onClick={handleConfirm} disabled={!selectedBounceHouse} className="flex-1 px-4 py-2 bg-primary-500 text-white rounded-md font-medium hover:bg-primary-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-62">
              Confirm Selection
            </button>
          </div>
        </div>
      </div>
    </div>;
};